<dgx-components-panel
  *ngIf="registeredAppliance"
  [border]="border"
  [rounded]="rounded"
  [variant]="variant"
>
  <h2 class="mb-4 typog-h3 protection-confirmation-panel__title">
    {{
      'SHARED_UI_REGISTRATION_CONFIRMATION_PANEL_TITLE_REGISTRATION_DETAILS'
        | translate
    }}
  </h2>

  <dgx-components-description-list
    class="registration-confirmation-appliance-details-panel__description-list mb-4"
  >
    <dgx-components-description-list-item
      [data]="registeredAppliance.type"
      [spaced]="true"
      [stacked]="stacked"
      [title]="
        'SHARED_UI_REGISTRATION_CONFIRMATION_MANUFACTURER_APPLIANCE_TYPE'
          | translate
      "
      [variant]="'bordered'"
    />

    <dgx-components-description-list-item
      *ngIf="registeredAppliance.modelNumber"
      [data]="registeredAppliance.modelNumber"
      [spaced]="true"
      [stacked]="stacked"
      [title]="'SHARED_UI_REGISTRATION_CONFIRMATION_MODEL_NUMBER' | translate"
      [variant]="'bordered'"
    />

    <dgx-components-description-list-item
      *ngIf="registeredAppliance.serialNumber"
      [data]="registeredAppliance.serialNumber"
      [spaced]="true"
      [stacked]="stacked"
      [title]="'SHARED_UI_REGISTRATION_CONFIRMATION_SERIAL_NUMBER' | translate"
      [variant]="'bordered'"
    />

    <dgx-components-description-list-item
      *ngIf="registeredAppliance.purchaseDate"
      [data]="registeredAppliance.purchaseDate | dateFormat : 'MM/dd/yyyy'"
      [spaced]="true"
      [stacked]="stacked"
      [title]="'SHARED_UI_REGISTRATION_CONFIRMATION_PURCHASE_DATE' | translate"
      [variant]="'bordered'"
    />
  </dgx-components-description-list>

  <us-registration-registria-snippet
    *ngIf="registriaUserResponse && registriaUserResponse.snippet_data"
    [registriaSnippet]="registriaUserResponse.snippet_data"
  />
</dgx-components-panel>
